import theme from 'shared/assets/style/theme';
import defaultTheme from './defaultTheme';
import Utils from 'shared/utils/index';

const windowWidth = window.innerWidth;

const ScrollBar = {
  ...defaultTheme.ScrollBar,
  backgroundColor: theme.palette.primary[31],
};

const TiTheme = {
  //TODO: Refactor ScrollBar styles
  ...defaultTheme,
  ScrollBar,
  LimitedTimeOffer: {
    ...defaultTheme.LimitedTimeOffer,
    BannerContainer: {
      ...defaultTheme.LimitedTimeOffer.BannerContainer,
      marginBottom: 10,
    },
    BuyButton: {
      ...defaultTheme.LimitedTimeOffer.BuyButton,
      bottom: '6%',
      transform: 'translateX(-1%)',
    },
  },
  NavigationBar: {
    ...defaultTheme.NavigationBar,
    LoyaltyCurrencyWrapperStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyle,
      right: `calc(50% - ${windowWidth < 1300 ? 195 : windowWidth < 1400 ? 205 : 270}px)`,
    },
    LoyaltyCurrencyWrapperStyleWithoutCard: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyleWithoutCard,
      right: `calc(50% - ${windowWidth < 1400 ? 215 : 320}px)`,
    },
    LoyaltyCurrencyIconStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyIconStyle,
      height: 60,
      width: 60,
      top: -15,
    },
    TopBar: {
      height: '5.5rem',
    },
    BarSection: {
      ...defaultTheme.NavigationBar.BarSection,
      paddingBottom: 10,
      maxWidth: Utils.ieVersion() !== 0 ? 1430 : 1600,
    },
    MiddleSection: {
      ...defaultTheme.NavigationBar.MiddleSection,
      margin: window.innerWidth > 1440 ? '0 9%' : 0,
    },
  },
  Tier: {
    ...defaultTheme.Tier,
    Card: {
      ...defaultTheme.Tier.Card,
      width: 75,
      top: -1,
    },
    TierWrapper: {
      ...defaultTheme.Tier.TierWrapper,
      marginRight: windowWidth < 1400 ? '75px !important' : '85px !important',
    },
  },
  BonusLinkMessage: {
    ...defaultTheme.BonusLinkMessage,
    PromoImage: {
      ...defaultTheme.BonusLinkMessage.PromoImage,
      paddingTop: '376px',
    },
    BonusLinkButton: {
      ...defaultTheme.BonusLinkMessage.BonusLinkButton,
      textShadow: `1px 1px 0px ${theme.palette.secondary[0]}, 1px -1px 0px ${theme.palette.secondary[0]}, -1px 1px 0px ${theme.palette.secondary[0]}, -1px -1px 0px ${theme.palette.secondary[0]}`,
    },
  },
  OutOfCoin: {
    ...defaultTheme.OutOfCoin,
    QuickBuyOfferDetails: {
      ...defaultTheme.OutOfCoin.QuickBuyOfferDetails,
      bottom: '12.5%',
    },
  },
  Settings: {
    ...defaultTheme.Settings,
    HeaderImage: {
      ...defaultTheme.Settings.HeaderImage,
      height: '6rem',
    },
    HeaderContent: {
      ...defaultTheme.Settings.HeaderContent,
      width: ' 100%',
      height: '80%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 5vmin',
    },
    BackArrowContainer: {
      ...defaultTheme.Settings.BackArrowContainer,
      top: '1.5rem',
    },
  },
  Messages: {
    ...defaultTheme.Messages,
    ScrollBar,
    HeaderContainer: {
      ...defaultTheme.Messages.HeaderContainer,
      height: '6rem',
    },
    HeaderTitle: {
      ...defaultTheme.Messages.HeaderTitle,
      lineHeight: '80px',
    },
  },
  CreditCardDetails: {
    ...defaultTheme.CreditCardDetails,
    CheckBoxBackgroundImage: {
      ...defaultTheme.CreditCardDetails.CheckBoxBackgroundImage,
      width: '40%',
    },
  },
  LinkAccountForm: {
    ...defaultTheme.LinkAccountForm,
    HeaderImage: {
      ...defaultTheme.LinkAccountForm.HeaderImage,
      height: '6rem',
    },
    HeaderTitle: {
      ...defaultTheme.LinkAccountForm.HeaderTitle,
      lineHeight: '80px',
    },
    FormContainer: {
      ...defaultTheme.LinkAccountForm.FormContainer,
      margin: '50px',
      marginBottom: '10px',
    },
  },
  RegisterRewardCard: {
    ...defaultTheme.RegisterRewardCard,
    HeaderImage: {
      ...defaultTheme.RegisterRewardCard.HeaderImage,
      height: '6rem',
    },
    HeaderTitle: {
      ...defaultTheme.RegisterRewardCard.HeaderTitle,
      lineHeight: '80px',
    },
    FormDescription: {
      ...defaultTheme.RegisterRewardCard.FormDescription,
      marginTop: '20px',
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    BottomBarBackgroundWrapperImage: {
      ...defaultTheme.DailySpin.BottomBarBackgroundWrapperImage,
      width: '120%',
      height: '150%',
    },
    MilestoneLoyaltyValue: {
      ...defaultTheme.DailySpin.MilestoneLoyaltyValue,
      marginLeft: -2,
    },
  },
  MessageDetails: {
    ...defaultTheme.MessageDetails,
    ScrollBar,
  },
  HistoryList: {
    ...defaultTheme.HistoryList,
    ScrollBar,
  },
  OfferList: {
    ...defaultTheme.OfferList,
    ScrollBar,
  },
  MissionsProgress: {
    ...defaultTheme.MissionsProgress,
    MissionIcon: {
      ...defaultTheme.MissionsProgress.MissionIcon,
      right: windowWidth < 1300 ? 'calc(50% - 327px)' : windowWidth < 1400 ? 'calc(50% - 340px)' : 'calc(50% - 415px)',
    },
    MissionIconWithoutCard: {
      ...defaultTheme.MissionsProgress.MissionIconWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 360px)' : windowWidth < 1400 ? 'calc(50% - 380px)' : 'calc(50% - 485px)',
    },
    BaseBar: {
      ...defaultTheme.MissionsProgress.BaseBar,
      right: windowWidth < 1300 ? 'calc(50% - 454px)' : windowWidth < 1400 ? 'calc(50% - 474px)' : 'calc(50% - 589px)',
    },
    BaseBarWithoutCard: {
      ...defaultTheme.MissionsProgress.BaseBarWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 534px)' : windowWidth < 1400 ? 'calc(50% - 554px)' : 'calc(50% - 659px)',
    },
    FillBar: {
      ...defaultTheme.MissionsProgress.FillBar,
      right: windowWidth < 1300 ? 'calc(50% - 475px)' : windowWidth < 1400 ? 'calc(50% - 495px)' : 'calc(50% - 587px)',
    },
    FillBarWithoutCard: {
      ...defaultTheme.MissionsProgress.FillBarWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 532px)' : windowWidth < 1400 ? 'calc(50% - 552px)' : 'calc(50% - 657px)',
    },
    TimeBar: {
      ...defaultTheme.MissionsProgress.TimeBar,
      right: windowWidth < 1300 ? 'calc(50% - 437px)' : windowWidth < 1400 ? 'calc(50% - 457px)' : 'calc(50% - 562px)',
    },
    TimeBarWithoutCard: {
      ...defaultTheme.MissionsProgress.TimeBarWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 507px)' : windowWidth < 1400 ? 'calc(50% - 527px)' : 'calc(50% - 632px)',
    },
    CollectBar: {
      ...defaultTheme.MissionsProgress.CollectBar,
      right: windowWidth < 1300 ? 'calc(50% - 458px)' : windowWidth < 1400 ? 'calc(50% - 478px)' : 'calc(50% - 590px)',
    },
    CollectBarWithoutCard: {
      ...defaultTheme.MissionsProgress.CollectBarWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 537px)' : windowWidth < 1400 ? 'calc(50% - 553px)' : 'calc(50% - 660px)',
    },
    TimeRemainingText: {
      ...defaultTheme.MissionsProgress.TimeRemainingText,
      top: windowWidth < 1400 ? 48 : 56,
      right: windowWidth < 1300 ? 'calc(50% - 410px)' : windowWidth < 1400 ? 'calc(50% - 430px)' : 'calc(50% - 525px)',
    },
    TimeRemainingTextWithoutCard: {
      ...defaultTheme.MissionsProgress.TimeRemainingTextWithoutCard,
      right: windowWidth < 1300 ? 'calc(50% - 475px)' : windowWidth < 1400 ? 'calc(50% - 495px)' : 'calc(50% - 600px)',
    },
    TextProgress: {
      ...defaultTheme.MissionsProgress.TextProgress,
      left: windowWidth < 1400 ? 50 : 65,
      top: windowWidth < 1400 ? '-47%' : '-8%',
    },
    FillProgressWithoutCard: {
      ...defaultTheme.MissionsProgress.FillProgressWithoutCard,
      marginLeft: '-25px',
    },
    FillProgress: {
      ...defaultTheme.MissionsProgress.FillProgress,
      marginLeft: windowWidth < 1400 ? '-17px' : '-25px',
      marginTop: windowWidth < 1400 ? '-22px' : '-17px',
    },
    FillEnd: {
      ...defaultTheme.MissionsProgress.FillEnd,
      marginTop: windowWidth < 1400 ? '-22px' : '-17px',
    },
    ProgressAnimation: {
      ...defaultTheme.MissionsProgress.ProgressAnimation,
      bottom: windowWidth < 1400 ? '-150%' : '-76%',
      left: windowWidth < 1400 ? '-10%' : '-9%',
    },
  },
  LinkAccount: {
    ...defaultTheme.LinkAccount,
    Description: {
      ...defaultTheme.LinkAccount.Description,
      padding: '0 7.5%',
    },
    LinkAccountContainer: {
      ...defaultTheme.LinkAccount.LinkAccountContainer,
      position: 'relative',
    },
    AvailableCards: {
      ...defaultTheme.LinkAccount.AvailableCards,
      position: 'absolute',
      margin: '3.5rem 7rem',
    },
    LightDividerUp: {
      ...defaultTheme.LinkAccount.LightDividerUp,
      display: 'flex',
    },
    LightDividerDown: {
      ...defaultTheme.LinkAccount.LightDividerDown,
      display: 'flex',
    },
  },
  ShopScreen: {
    ...defaultTheme.ShopScreen,
    ShopContainer: {
      ...defaultTheme.ShopScreen.ShopContainer,
      PackagesContainer: {
        ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer,
        padding: '6% 5.5rem 0.65rem',
      },
    },
    SaleTimer: {
      ...defaultTheme.ShopScreen.SaleTimer,
      top: '10%',
    },
  },
  FormButton: {
    ...defaultTheme.FormButton,
    LinkBtn: {
      ...defaultTheme.FormButton.LinkBtn,
      backgroundImage: `url(${require(asset`RoundedRect_Green@2x.png`)}`,
    },
  },
  FormFooter: {
    ...defaultTheme.FormFooter,
    TermsLink: {
      ...defaultTheme.FormFooter.TermsLink,
      color: theme.palette.primary[0],
    },
  },
  MessagesHeader: {
    ...defaultTheme.MessagesHeader,
    Image: {
      ...defaultTheme.MessagesHeader.Image,
      height: '6rem',
    },
  },
  Start: {
    ...defaultTheme.Start,
    BottomBarFirstLine: {
      ...defaultTheme.Start.BottomBarFirstLine,
      marginTop: 35,
    },
  },
  CoinItem: {
    ...defaultTheme.CoinItem,
    CoinAmount: {
      ...defaultTheme.CoinItem.CoinAmount,
      fontSize: '22px',
    },
    Extra: {
      ...defaultTheme.CoinItem.Extra,
      fontSize: '1vmin',
      marginTop: 0,
    },
  },
  RewardHome: {
    ...defaultTheme.RewardHome,
    RewardImagePlaceholder: {
      ...defaultTheme.RewardHome.RewardImagePlaceholder,
      borderRadius: '30px',
    },
    RewardImage: {
      ...defaultTheme.RewardHome.RewardImage,
      borderRadius: '30px',
    },
    RewardHoverOverlay: {
      ...defaultTheme.RewardHome.RewardHoverOverlay,
      borderRadius: '30px',
    },
  },
  RewardListItem: {
    ...defaultTheme.RewardListItem,
    RewardImagePlaceholderContainer: {
      ...defaultTheme.RewardListItem.RewardImagePlaceholderContainer,
      borderRadius: '30px',
    },
    OfferCost: {
      ...defaultTheme.RewardListItem.OfferCost,
      height: '11%',
      top: '-28.5%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '4px',
      marginBottom: '0.5em',
    },
    OfferName: {
      ...defaultTheme.RewardListItem.OfferName,
      top: windowWidth < 1450 ? '-36%' : '-32%',
    },
  },
  SignUp: {
    ...defaultTheme.SignUp,
    ErrorMessage: {
      ...defaultTheme.SignUp.ErrorMessage,
      color: theme.palette.common[1],
    },
  },
  NotificationModal: {
    ...defaultTheme.NotificationModal,
    HeaderContainer: {
      ...defaultTheme.NotificationModal.HeaderContainer,
      height: '25%',
    },
  },
};

export default TiTheme;

